import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Slider from '../Slider'

const titleMap = {
    tier1: '0-1 min',
    tier2: '1-5 min',
    tier3: '5-30 min',
    tier4: '30-60 min',
    tier5: '60-90 min',
    tier6: '90-120 min'
}

class MasterDeliverySliders extends Component {
    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return nextProps.usage !== this.props.usage
    }

    editUsage(callback) {
        const usage = { ...this.props.usage }
        callback(usage)
        this.props.onChange(usage)
    }

    render() {
        return (
            <div>
                {Object.keys(this.props.usage).map(key => {
                    return (
                        <Slider
                            onChange={value => {
                                this.editUsage(usage => (usage[key] = value))
                            }}
                            max={1000}
                            step={1}
                            value={this.props.usage[key]}
                            title={titleMap[key]}
                            key={key}
                        />
                    )
                })}
            </div>
        )
    }
}

MasterDeliverySliders.propTypes = {
    usage: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired
}

export default MasterDeliverySliders
